import { VoteIcon, EyeIcon, MessageSquareIcon } from 'lucide-react';
import type { Snap } from '@/types/database.types';

interface SnapStatsProps {
  snap: Snap;
  commentsCount: number;
}

export default function SnapStats({ snap, commentsCount }: SnapStatsProps) {
  return (
    <div className="bg-gradient-to-r from-primary-600/5 to-primary-600/10 border-y border-primary-100">
      <div className="container mx-auto px-4 sm:px-6 py-4">
        <div className="grid grid-cols-3 gap-2 sm:gap-4">
          <div className="flex flex-col items-center justify-center p-3 sm:p-4 rounded-lg bg-white/50 backdrop-blur-sm border border-primary-100 transition-all hover:bg-white/80">
            <div className="flex items-center text-primary-600">
              <VoteIcon className="h-5 sm:h-5 w-5 sm:w-5 sm:mr-2" />
              <span className="hidden sm:inline font-medium">Total Votes</span>
            </div>
            <div className="flex items-baseline mt-1">
              <span className="text-lg sm:text-2xl font-bold text-gray-900">{snap.total_votes}</span>
              <span className="ml-1 text-xs sm:text-sm text-gray-500 hidden sm:inline">votes</span>
            </div>
          </div>

          <div className="flex flex-col items-center justify-center p-3 sm:p-4 rounded-lg bg-white/50 backdrop-blur-sm border border-primary-100 transition-all hover:bg-white/80">
            <div className="flex items-center text-primary-600">
              <EyeIcon className="h-5 sm:h-5 w-5 sm:w-5 sm:mr-2" />
              <span className="hidden sm:inline font-medium">Views</span>
            </div>
            <div className="flex items-baseline mt-1">
              <span className="text-lg sm:text-2xl font-bold text-gray-900">{snap.view_count}</span>
              <span className="ml-1 text-xs sm:text-sm text-gray-500 hidden sm:inline">views</span>
            </div>
          </div>

          <div className="flex flex-col items-center justify-center p-3 sm:p-4 rounded-lg bg-white/50 backdrop-blur-sm border border-primary-100 transition-all hover:bg-white/80">
            <div className="flex items-center text-primary-600">
              <MessageSquareIcon className="h-5 sm:h-5 w-5 sm:w-5 sm:mr-2" />
              <span className="hidden sm:inline font-medium">Comments</span>
            </div>
            <div className="flex items-baseline mt-1">
              <span className="text-lg sm:text-2xl font-bold text-gray-900">{commentsCount}</span>
              <span className="ml-1 text-xs sm:text-sm text-gray-500 hidden sm:inline">comments</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}